import { IOpsSchedule } from '@nkr/models/index';
import { IDayWithValidation } from './day-with-validation';

export interface IOpsScheduleWithValidation extends IOpsSchedule {
    validEmployee: boolean,
    days: IDayWithValidation[]
}